import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
export { default as BaseCheckbox } from '@mui/material/Checkbox';
import CircularCheckbox from './CircularCheckbox.js';
import DefaultCheckbox from './DefaultCheckbox.js';

var Checkbox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'square' : _props$variant;
  if (variant === 'circle') {
    return /*#__PURE__*/React__default.createElement(CircularCheckbox, _extends({}, props, {
      ref: ref
    }));
  }
  return /*#__PURE__*/React__default.createElement(DefaultCheckbox, _extends({}, props, {
    ref: ref
  }));
});
Checkbox.displayName = 'Checkbox';
var Checkbox$1 = /*#__PURE__*/React__default.memo(Checkbox);

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
